import type { Props as ParentProps } from '../../types'

export type Props = Omit<ParentProps, 'imgMobile' | 'video' | 'videoPoster'>

export interface StylesProps {
  bgImage?: string,
  bgPosition?: BgPosition,
  right?: boolean,
  isLoading?: boolean,
  isLargeHeight?: boolean,
  hasOpacity?: boolean,
}

export enum BgPosition {
  center = 'center center',
  right = 'right center',
  left = 'left center',
  topRight = 'top right',
}
